import * as React from 'react';
import logo from '../../../images/logo.svg';
import { Link, Navigate } from 'react-router-dom';

const baseUrl = process.env.REACT_APP_BASE_URL || 'https://app-api.spinndo.com/api';

export interface INewAccountProps {}

export interface INewAccountState {
  first_name: string;
  first_name_ar: string;
  last_name: string;
  last_name_ar: string;
  email: string;
  password: string;
  confirm_password: string;
  error: string;
  success: string;
  accountCreated: boolean;
}

export default class NewAccount extends React.Component<INewAccountProps, INewAccountState> {
  constructor(props: INewAccountProps) {
    super(props);
    this.state = {
      first_name: '',
      first_name_ar: '',
      last_name: '',
      last_name_ar: '',
      email: '',
      password: '',
      confirm_password: '',
      error: '',
      success: '',
      accountCreated: false,
    };
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    this.setState({ ...this.state, [name]: value });
  };

  handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const { first_name, first_name_ar, last_name, last_name_ar, email, password, confirm_password } = this.state;

    if (password !== confirm_password) {
      this.setState({ error: 'كلمتا المرور غير متطابقتين.', success: '' });
      return;
    }

    try {
      const response = await fetch(`${baseUrl}/signUp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
                    'Accept-Language': 'en',
         },
        body: JSON.stringify({
          first_name,
          first_name_ar,
          last_name,
          last_name_ar,
          email,
          password
        })
      });

      const result = await response.json();

      if (response.ok && result.status === 'success') {
        this.setState({ success: 'تم إنشاء الحساب بنجاح.', error: '', accountCreated: true });
      } else {
        this.setState({ error: result.message || 'حدث خطأ أثناء إنشاء الحساب.', success: '' });
      }
    } catch (err: any) {
      this.setState({ error: err.message || 'خطأ في الاتصال بالخادم.', success: '' });
    }
  };

  render() {
    if (this.state.accountCreated) {
      return <Navigate to="/Verify" replace />;
    }

    return (
      <div className="flex flex-col items-center justify-center px-6 pt-8 mx-auto md:h-screen pt:mt-0 dark:bg-gray-900">
        <img src={logo} className="mr-4 h-11" alt="FlowBite Logo" />
        <span>Flowbite</span>

        <div className="w-full max-w-xl p-6 space-y-8 sm:p-8 bg-white rounded-lg shadow dark:bg-gray-800">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            Create a Free Account
          </h2>
          <form className="mt-8 space-y-6" onSubmit={this.handleSubmit}>
            {[
              { id: 'first_name', label: 'First Name', type: 'text' },
              { id: 'first_name_ar', label: 'الاسم الأول', type: 'text' },
              { id: 'last_name', label: 'Last Name', type: 'text' },
              { id: 'last_name_ar', label: 'اسم العائلة', type: 'text' },
              { id: 'email', label: 'Your email', type: 'email' },
              { id: 'password', label: 'Your password', type: 'password', autoComplete: 'new-password' },
              { id: 'confirm_password', label: 'Confirm password', type: 'password', autoComplete: 'new-password' }
            ].map(({ id, label, type, autoComplete }) => (
              <div key={id}>
                <label htmlFor={id} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  {label}
                </label>
                <input
                  type={type}
                  name={id}
                  id={id}
                  value={(this.state as any)[id]}
                  onChange={this.handleChange}
                  required
                  autoComplete={autoComplete}
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                />
              </div>
            ))}

            <div className="flex items-start">
              <div className="flex items-center h-5">
                <input id="remember" name="remember" type="checkbox" required className="w-4 h-4 border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:focus:ring-primary-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600" />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor="remember" className="font-medium text-gray-900 dark:text-white">
                  I accept the <a href="#" className="text-primary-700 hover:underline dark:text-primary-500">Terms and Conditions</a>
                </label>
              </div>
            </div>

            <button type="submit" className="w-full px-5 py-3 text-base font-medium text-center text-white bg-primary-700 rounded-lg hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 sm:w-auto dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
              Create account
            </button>

            <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
              <Link to="/" className="hover:underline">Already have an account?</Link>
            </div>

            {this.state.error && <div className="text-red-500 text-sm">{this.state.error}</div>}
            {this.state.success && <div className="text-green-500 text-sm">{this.state.success}</div>}
          </form>
        </div>
      </div>
    );
  }
}
